require('custom/accordion');
require('custom/form-checkbox');
require('custom/type-design-id');
require('custom/product-card-pillow');
require('custom/utils');
require('custom/gtm-datalayer');
import { liteClient as algoliasearch } from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import {
  clearRefinements,
  configure,
  menuSelect,
  pagination,
  refinementList,
  searchBox,
  sortBy,
  stats,
  toggleRefinement,
} from 'instantsearch.js/es/widgets';
import {
  connectCurrentRefinements,
  connectHits,
  connectInfiniteHits,
  connectNumericMenu,
  connectRefinementList,
  connectSearchBox,
  connectSortBy,
} from 'instantsearch.js/es/connectors';
import tippy from 'tippy.js';

// Attach widget/connector namespaces so algolia-widget-builder can use
// instantsearch.widgets.* and instantsearch.connectors.* previously before
let algoliaEsHolder = {};
algoliaEsHolder.widgets = {
  clearRefinements,
  configure,
  menuSelect,
  pagination,
  refinementList,
  searchBox,
  sortBy,
  stats,
  toggleRefinement,
};
algoliaEsHolder.connectors = {
  connectCurrentRefinements,
  connectHits,
  connectInfiniteHits,
  connectNumericMenu,
  connectRefinementList,
  connectSearchBox,
  connectSortBy,
};
import {
  DEFAULT_ATTR_TO_RETRIEVE,
  EXCLUDE_FILTER,
  HIDE_COLLAB,
  NON_FILTER,
} from '../common/constant';

/*
REFERENCE DOCS
https://www.algolia.com/doc/api-reference/widgets/instantsearch/js/
*/

custom.algoliaSearch = (function () {
  /**
   * customAlgoliaSearch method
   * @params options - An options object
   * @requires options.id - Algolia Search Account ID
   * @requires options.key - Algolia Search Key
   * @requires options.instantSearchIndex - Instant Search Index
   */
  let init = (options = {}) => {
    // Presets
    const defaults = {
      id: algoliaShopify.config.app_id, // Account ID
      key: algoliaShopify.config.search_api_key, // Account Key
      gtm_list_name: 'Category',
      gtm_list_id: 'PLP',
      instantSearchIndex: null, // InstantSearch Index
      instantSearchLimit: 48, // Hits per page
      instantSearchFilter: '', // Type to filter (ie. Rugs, Latest, etc)
      searchIndex: null, // Search Index
      searchFilter: '', // Type to filter (ie. Rugs, Latest, etc)
      searchLimit: 6, // Search limit
      resultsContainerID: 'searchResults', // Results ID
      loadMore: true,
      loadMoreContainerID: 'loadMore', // Load More ContainerID
      loadMoreID: 'load-more', // Button ID
      widgets: [], // Widgets,
      attributesToRetrieve: null,
      passDataToTemplate: null, // Run data through frontend template
      cardRenderedCallback: null, // Do something with UI after rendering
      resultsLoadedCallback: null, // Do something after payload is added to DOM
      discontinuedHeader: true, // whether to insert header or not
      useExcludeFilter: true, // whether to exclude color blocks or not
      hideOnNoResults: true, // whether to hide entire area when no search results come in
    };

    // Merge args
    const opts = Object.assign({}, defaults, options);

    // Test for Algolia Account ID (required)
    try {
      if (!opts.id) {
        throw 'Please provide an Algolia Account ID (options.id)';
      }
    } catch (e) {
      console.log('error: ', e);
      return;
    }

    // Test for Algolia Account Key (required)
    try {
      if (!opts.key) {
        throw 'Please provide an Algolia Account Key (options.key)';
      }
    } catch (e) {
      console.log('error: ', e);
      return;
    }

    // Test for instantSearchIndex (required)
    try {
      if (!opts.instantSearchIndex) {
        throw 'Please provide an Algolia Search Index (options.instantSearchIndex)';
      }
    } catch (e) {
      console.log('error: ', e);
      return;
    }

    /**
     *  Default Attributes and Filter
     *  @default
     */
    if (!opts.attributesToRetrieve)
      opts.attributesToRetrieve = DEFAULT_ATTR_TO_RETRIEVE;
    if (opts.useExcludeFilter) {
      opts.instantSearchFilter =
        opts.instantSearchFilter != ''
          ? `${EXCLUDE_FILTER} AND ${opts.instantSearchFilter}`
          : EXCLUDE_FILTER;
    }

    // Initialize instantsearch
    const searchClient = algoliasearch(opts.id, opts.key);
    const myInstantSearch = instantsearch({
      searchClient,
      appId: opts.id,
      apiKey: opts.key,
      indexName: opts.instantSearchIndex,
      insights: {
        insightsInitParams: {
          useCookie: true,
        },
      },
      routing: {
        stateMapping: {
          // Github issue https://github.com/Loloi-Rugs-Inc/loloi-rugs-shopify-theme/issues/119
          // Fix: Properly strip page from the state before writing route to url (also leave out configure).
          // https://www.algolia.com/doc/api-reference/widgets/ui-state/js
          stateToRoute(uiState) {
            const indexUiState = uiState[opts.instantSearchIndex] || {};
            // Create a copy without the page parameter
            const { page, configure, ...stateWithoutPage } = indexUiState;
            return {
              [opts.instantSearchIndex]: stateWithoutPage,
            };
          },
          routeToState(routeState) {
            // Default sort index has changed (alphabetical -> newest), this next part fixes old links with the alphabetical/old default.
            const legacyDefaultIndex = window.AlgoliaIndices.products;
            if (
              legacyDefaultIndex !== opts.instantSearchIndex &&
              routeState[legacyDefaultIndex] &&
              !routeState[opts.instantSearchIndex]
            ) {
              const { [legacyDefaultIndex]: legacyState, ...rest } = routeState;
              return {
                ...rest,
                [opts.instantSearchIndex]: legacyState,
              };
            }
            return routeState;
          },
        },
      },
      onStateChange({ uiState, setUiState }) {
        // Keeps track of whether or not a filter has been applied for hiding/showing collections on applicable pages
        let refinementApplied = false;
        let refinementsCount = 0;
        Object.keys(uiState).forEach(function (key) {
          if (
            uiState[key].numericMenu ||
            uiState[key].refinementList ||
            uiState[key].toggle
          ) {
            refinementApplied = true;
            refinementsCount++;
          }
        });
        state.filterApplied = refinementApplied;
        custom.algoliaUtils.updateFiltersBar(refinementsCount);
        custom.algoliaUtils.updateDoorwayDriver(refinementsCount);
        custom.algoliaUtils.refreshTippy();
        state.setRefinementStateFresh = true;
        state.setQueryStateFresh = true;
        setUiState(uiState);
      },
    });
    myInstantSearch.addWidgets([
      algoliaEsHolder.widgets.configure({
        distinct: true,
        maxValuesPerFacet: 20,
        hitsPerPage: opts.instantSearchLimit,
        filters: opts.instantSearchFilter,
        facetingAfterDistinct: true,
        attributesToRetrieve: opts.attributesToRetrieve,
        facetingAfterDistinct: false,
      }),
    ]);

    let collectionInstantSearch;

    if (opts.searchIndex) {
      collectionInstantSearch = instantsearch({
        searchClient,
        appId: opts.id,
        apiKey: opts.key,
        indexName: opts.searchIndex,
        insights: true,
      });
      collectionInstantSearch.addWidgets([
        algoliaEsHolder.widgets.configure({
          distinct: true,
          hitsPerPage: opts.instantSearchLimit,
          filters: opts.searchFilter,
          facetingAfterDistinct: true,
          attributesToRetrieve: opts.attributesToRetrieve,
        }),
        algoliaEsHolder.widgets.stats({
          container: '#productResultsCount-collection',
          templates: {
            root: '',
            header: '',
            text: function (data) {
              var statText = '';
              if (data.hasManyResults) {
                statText = data.nbHits + ' Results';
              } else if (data.hasOneResult) {
                statText = '1 Result';
              } else {
                statText = '';
              }
              return statText;
            },
          },
        }),
      ]);
    }

    /**
     * State Data via Proxy
     * now only using for refinements, but could use for DOM cache?
     */
    window.searchState = window.searchState || [];
    window.searchState[opts.resultsContainerID] = {
      recentQueryIds: [],
      refinements: [],
      refinementsChange: false,
      currentIndex: opts.instantSearchIndex,
      indexChange: false,
      currentCollectionIndex: opts.searchIndex,
      indexCollectionChange: false,
      currentQuery: '',
      queryChange: false,
      filterApplied: false,
      hasDiscontinuedAppeared: false,
      currentPage: '',
      pageChange: false,
      currentCollectionPage: '',
      pageCollectionChange: false,
      newSearchRunning: true,
      setRefinementStateFresh: true,
      setQueryStateFresh: true,
      firstLoadComplete: false,
      initialRenderComplete: false,
      initialCollectionRenderComplete: false,
    };

    // Create proxy-able state object
    let state = (() => window.searchState[opts.resultsContainerID])();

    // Boolean value of refinements being changed or not
    function RefinementsChanged(prevRefinements = [], currentRefinements = []) {
      if (prevRefinements.length != currentRefinements.length) return true;

      let price = {};
      let allMatchesFound = true;

      prevRefinements.forEach((refinement) => {
        if (refinement.type == 'numeric') price.prev = refinement.name;
        const match = currentRefinements.find(
          (currentRefinement) =>
            currentRefinement.attribute === refinement.attribute,
        );
        if (
          !match ||
          match.refinements.length !== refinement.refinements.length
        ) {
          allMatchesFound = false;
        } else {
          refinement.refinements.forEach((refinement2) => {
            const match2 = match.refinements.find(
              (matchRefinement) => matchRefinement.value === refinement2.value,
            );
            if (!match2) {
              allMatchesFound = false;
            }
          });
        }
      });
      currentRefinements.forEach((refinement) => {
        if (refinement.type == 'numeric') price.current = refinement.name;
        const match = prevRefinements.find(
          (currentRefinement) =>
            currentRefinement.attribute === refinement.attribute,
        );
        if (
          !match ||
          !match.refinements ||
          match.refinements.length !== refinement.refinements.length
        ) {
          allMatchesFound = false;
        } else {
          refinement.refinements.forEach((refinement2) => {
            const match2 = match.refinements.find(
              (matchRefinement) => matchRefinement.value === refinement2.value,
            );
            if (!match2) {
              allMatchesFound = false;
            }
          });
        }
      });
      if (!allMatchesFound) return true;

      return price.prev && price.current && price.prev != price.current
        ? true
        : false;
    }

    // Set Refinements to State
    function setRefinementState(payload = []) {
      if (state.setRefinementStateFresh) {
        state.refinementsChange = RefinementsChanged(
          state.refinements,
          payload,
        );
        state.setRefinementStateFresh = false;
        if (state.refinements.length > 0 && payload.length > 0) {
          state.indexChange =
            state.refinements[0].indexName !== payload[0].indexName;
        }
      }
      state.refinements = payload;
      if (state.refinementsChange) state.hasDiscontinuedAppeared = false;
    }

    // Set Search Index to State
    function setSearchIndexState(indexName = '', widgetParams = null) {
      state.indexChange = state.currentIndex != indexName ? true : false;
      state.currentIndex = indexName;
      if (state.indexChange && collectionInstantSearch && widgetParams) {
        state.hasDiscontinuedAppeared = false;
        // Set the corresponding index on the collection/product search.
        setPairedSortBy(indexName, widgetParams);
      }
    }

    // Set Search Collection Index to State
    function setSearchCollectionIndexState(
      indexName = '',
      widgetParams = null,
    ) {
      state.indexCollectionChange =
        state.currentCollectionIndex != indexName ? true : false;
      state.currentCollectionIndex = indexName;
      if (
        state.indexCollectionChange &&
        collectionInstantSearch &&
        widgetParams
      ) {
        state.hasDiscontinuedAppeared = false;
        // Set the corresponding index on the collection/product search.
        setPairedSortBy(indexName, widgetParams);
      }
    }

    function setPairedSortBy(indexName, widgetParams) {
      const { pairedContainer, pairedData } = widgetParams;
      if (pairedContainer && pairedData) {
        const selectedOption = pairedData.find((x) => x.name === indexName);
        const targetIndex =
          selectedOption && selectedOption.target
            ? selectedOption.target
            : null;
        const $targetSelect = $(`${pairedContainer} select`);
        if (
          targetIndex &&
          $targetSelect.val() &&
          targetIndex !== $targetSelect.val()
        ) {
          $targetSelect.val(targetIndex).change();
          if (targetIndex.indexOf('products') > -1) {
            myInstantSearch.helper.state.index = targetIndex;
          } else {
            collectionInstantSearch.helper.state.index = targetIndex;
          }
        }
      }
    }

    // Set Page to State
    function setSearchPageState(page = 0) {
      state.pageChange = state.currentPage !== page ? true : false;
      state.currentPage = page;
    }

    // Set Collection Page to State
    function setSearchCollectionPageState(page = 0) {
      state.pageCollectionChange =
        state.currentCollectionPage !== page ? true : false;
      state.currentCollectionPage = page;
    }

    // Set Search Query to State
    function setQueryState(query = '') {
      if (state.setQueryStateFresh) {
        state.queryChange = state.currentQuery != query ? true : false;
        if (query && query != '' && state.currentQuery != query) {
          //Update changes to search Query in GTM Data Layer
          const data = {
            search_term: query,
          };
          custom.gtmDatalayer.gtmPushNew(data, 'search');
        }
        state.setQueryStateFresh = false;
      }
      state.currentQuery = query;
      if (state.queryChange) {
        state.hasDiscontinuedAppeared = false;
      }
    }

    /*
     * renderResults
     *
     * @param {string} output - rendered string of DOM object
     * @param {boolean} collectionMode - identifier of collection or not
     * - Injects rendered result in DOM
     */
    const renderResults = (
      output,
      collectionMode = false,
      isLastPage = false,
      resultQueryID = '',
    ) => {
      const targetId = collectionMode
        ? `${opts.resultsContainerID}-collection`
        : opts.resultsContainerID;
      SearchModeHandler(collectionMode, isLastPage);
      // Whether this mode (product vs. collection) has ever rendered real results
      // before now -- lets us tell a genuine user-triggered refinement/index change
      // apart from the initial page load simply reflecting filters baked into the URL.
      const hasRenderedBefore = collectionMode
        ? state.initialCollectionRenderComplete
        : state.initialRenderComplete;
      // Add all hits to the results container in the DOM
      if (
        state.refinementsChange ||
        (!collectionMode && state.indexChange) ||
        (collectionMode && state.indexCollectionChange) ||
        state.queryChange
      ) {
        //Check for and insert In Situ content if no filter is present.
        if (!state.filterApplied && $('#in-situ-content').length) {
          const inSituContent = $('#in-situ-content').html();
          output = inSituContent + output;
        }
        document.getElementById(targetId).innerHTML = output;
        if (!state.queryChange && hasRenderedBefore)
          custom.utils.scrollTo($(`#${targetId}`).closest('.product-showcase'));
      } else {
        if (
          !state.filterApplied &&
          $('#in-situ-content').length &&
          !$(`#${targetId} .in-situ`).length
        ) {
          const inSituContent = $('#in-situ-content').html();
          $(`#${targetId}`).prepend(inSituContent);
        }
        $(`#${targetId}`).append($.parseHTML(output));
      }
      if (collectionMode) {
        state.initialCollectionRenderComplete = true;
      } else {
        state.initialRenderComplete = true;
      }

      // Function to check for overflow and set tooltip on product card titles
      custom.overflowTooltip.init('product-card__name');

      // BUGFIX LR-719: Clean up the recentQueryIds array to only store the current queryId
      state.recentQueryIds = [];
      if (resultQueryID) {
        state.recentQueryIds.push(resultQueryID);
      }
    };

    /*
     * SearchModeHandler
     *
     * @param {boolean} collectionMode - identifier of collection or not
     * - Injects rendered result in DOM
     */
    const SearchModeHandler = (collectionMode = false, isLastPage = false) => {
      const $productContainer = $(`#${opts.resultsContainerID}`);
      const $productApplyButton = $('#stats-apply');
      const $productSortBy = $('.sort-by-selector');
      const $productLoadMore = $(`#${opts.loadMoreID}`);
      const $productLoadMoreContainer = $(`#${opts.loadMoreContainerID}`);
      const $productResultsCount = $(`#productResultsCount`);

      collectionMode
        ? $productContainer.addClass('hidden')
        : $productContainer.removeClass('hidden');
      collectionMode
        ? $productSortBy.addClass('hidden')
        : $productSortBy.removeClass('hidden');
      collectionMode
        ? $productApplyButton.addClass('hidden')
        : $productApplyButton.removeClass('hidden');
      if ($productLoadMore) {
        $productLoadMore.prop('disabled', collectionMode || isLastPage);
      }
      if ($productResultsCount) {
        collectionMode
          ? $productResultsCount.addClass('hidden')
          : $productResultsCount.removeClass('hidden');
      }
      collectionMode
        ? $productLoadMoreContainer.addClass('hidden')
        : $productLoadMoreContainer.removeClass('hidden');

      if (opts.searchIndex) {
        const $collectionContainer = $(
          `#${opts.resultsContainerID}-collection`,
        );
        const $collectionApplyButton = $('#stats-apply-collection');
        const $collectionSortBy = $('.sort-by-selector-collection');
        const $collectionLoadMore = $(`#${opts.loadMoreID}-collection`);
        const $collectionLoadMoreContainer = $(
          `#${opts.loadMoreContainerID}-collection`,
        );
        const $collectionResultsCount = $(`#productResultsCount-collection`);

        !collectionMode
          ? $collectionContainer.addClass('hidden')
          : $collectionContainer.removeClass('hidden');
        !collectionMode
          ? $collectionSortBy.addClass('hidden')
          : $collectionSortBy.removeClass('hidden');
        !collectionMode
          ? $collectionApplyButton.addClass('hidden')
          : $collectionApplyButton.removeClass('hidden');
        if ($collectionLoadMore) {
          $collectionLoadMore.prop('disabled', !collectionMode || isLastPage);
        }
        if ($collectionResultsCount) {
          !collectionMode
            ? $collectionResultsCount.addClass('hidden')
            : $collectionResultsCount.removeClass('hidden');
        }
        !collectionMode
          ? $collectionLoadMoreContainer.addClass('hidden')
          : $collectionLoadMoreContainer.removeClass('hidden');
      }
    };

    const handleNoResults = (filterApplied = false) => {
      // show no results message
      const resultsContainer = document.getElementById(opts.resultsContainerID);
      resultsContainer.innerHTML =
        '<p class="title-small text-grey-6 mx-4 md-up:mx-6 my-8 pt-8 w-full searchResults__no-results">Sorry, no results found.</p>';
      if (!opts.hideOnNoResults) return;

      // hide collections with no results
      if (filterApplied) {
        SearchModeHandler(false, true);
      }

      document.getElementById(opts.loadMoreContainerID).innerHTML = '';
    };

    /**
     * CALLBACKS =============================================
     *
     * Allows us to alter the response before outputting to results container
     * We do this because we augment the InstantSearch object with a Products->Images Search Query
     */

    /**
     * Results　Loaded　Callback
     * All methods here get called ONCE on initial render.
     */
    const resultsLoadedCallback = (collectionMode = false) => {
      // Fire results loaded callback
      if (opts.resultsLoadedCallback) opts.resultsLoadedCallback();

      // If this is a load-more rendering
      custom.typeDesignId.init();
      custom.lazyImages.init();
      custom.productCardPillow.init();
      custom.algoliaSearchInsights.init();
    };

    /**
     * Initial Render Callback
     * All methods here get called ONCE on initial render.
     */
    const initialRenderCallback = () => {
      if (state.firstLoadComplete) return;
      state.firstLoadComplete = true;
      // Fade out skeleton loaders
      $('.js-skeleton').fadeOut(300);
      custom.Accordion.init();
      setTimeout(function () {
        tippy('.js-tippy', {
          animation: 'fade',
          appendTo: document.body,
          arrow: true,
          arrowTransform: 'scaleX(0.75)',
          placement: 'top',
          maxWidth: '238px',
          maxHeight: '81px',
          interactive: true,
        });
        custom.algoliaUtils.refreshTippy();
      }, 500);

      custom.algoliaUtils.removeChoosenFacets(NON_FILTER);

      // Looks for product category price filter
      if (document.getElementById('price')) {
        custom.FormCheckbox.init('.ais-RefinementList--radio');
      }
    };

    // Method to render cards to UI
    const renderCardsToUI = (
      hits,
      collectionMode = false,
      isLastPage = false,
      resultQueryID = '',
    ) => {
      // Initialize an empty output array
      let outputArray = [];
      let variantsPromises = [];
      let hitsLength = hits.length;
      // get prices in window ahead of rendering for product search
      if (hits.length > 0 && !collectionMode) {
        let hit_sku = [];
        let is_oak = false;
        hits.forEach((hit) => {
          if (
            !is_oak &&
            hit.named_tags &&
            hit.named_tags.Collaboration &&
            hit.named_tags.Collaboration == 'One-of-a-Kinds'
          )
            is_oak = true;
          hit_sku.push(hit.sku);
        });
        //get prices if its OAKS
        if (is_oak) {
          custom.utils.getCustomProductPrices(hit_sku);
        }
      }
      while (hitsLength > 0) {
        outputArray.push('');
        hitsLength--;
      }

      //store first handle, just for duplicate check for PILLOWS/WALL ART
      let handle = '';
      const sizeFilterApplied =
        state.refinements &&
        state.refinements.find(
          (refinement) => refinement.attribute === 'meta.loloi.variant_option',
        );

      // Loop through each hit
      hits.forEach((hit, index) => {
        //catch duplicates
        if (
          document.getElementById(hit.handle) != null &&
          !(
            state.refinementsChange ||
            (!collectionMode && state.indexChange) ||
            (collectionMode && state.indexCollectionChange) ||
            state.queryChange
          )
        ) {
          return;
        }
        //Filter out discontinued items only if size filters have been applied

        if (sizeFilterApplied) {
          if (
            custom.algoliaUtils.hitIsDiscontinued(hit) &&
            hit.inventory_quantity <= 0
          )
            return;
        }

        handle = handle || hit.handle;

        hit = custom.algoliaUtils.resultObjectReducer(hit);
        let gtmListId = opts.gtm_list_id
          ? opts.gtm_list_id
          : 'Product Listing Page';
        if (state.currentQuery && state.currentQuery != '') {
          gtmListId = state.currentQuery;
        }
        hit.item_list_id = gtmListId;
        hit.item_list_name = opts.gtm_list_name
          ? opts.gtm_list_name
          : 'Category';
        hit.index = index + 1;
        hit.openNewTab = true;
        if (hit.named_tags && hit.named_tags.Collaboration)
          hit.hideCollaboration =
            HIDE_COLLAB.indexOf(hit.named_tags.Collaboration) >= 0 ||
            NON_FILTER.indexOf(hit.named_tags.Collaboration) >= 0;
        // NOTE: This looks redundant but is for collaborations instead of products
        if (hit.meta && hit.meta.loloi && hit.meta.loloi.collaboration) {
          hit.hide_collab =
            HIDE_COLLAB.indexOf(hit.meta.loloi.collaboration) >= 0 ||
            NON_FILTER.indexOf(hit.meta.loloi.collaboration) >= 0;
        }

        /*
         * Discontinued Divider
         * NOTE: Algolia Ranking should be set "Discontinued" as Ascendant
         */
        if (opts.discontinuedHeader) {
          const discontinued =
            opts.searchIndex && hit.isCollection
              ? hit.meta.loloi.discontinued == 1 ||
                hit.meta.loloi.discontinued.toUpperCase() == 'TRUE'
              : custom.algoliaUtils.hitIsDiscontinued(hit);
          if (!state.hasDiscontinuedAppeared && discontinued) {
            //Bugfix: If initial load already included discontinued items, don't add multiple dividers
            const existingDivider = hit.isCollection
              ? $(
                  `#${opts.resultsContainerID}-collection .discontinued-divider`,
                )
              : $(`#${opts.resultsContainerID} .discontinued-divider`);
            if (existingDivider.length === 0) {
              outputArray[index] +=
                '<div class="discontinued-divider w-full ml-3 md-up:ml-6 py-4 md-up:py-6 my-4 md-up:my-6 border-b rtype-title-medium">Discontinued</div>';
            }
            state.hasDiscontinuedAppeared = true;
          }
        }

        hit.lazyload = true;
        // PILLOWS
        if (
          hit.product_type === 'PILLOWS' ||
          hit.product_type === 'WALL ART' ||
          hit.product_type === 'POUFS'
        ) {
          const variantFetch = custom.shopifyApi.getShopifyProductJson(
            hit.handle,
          );

          variantsPromises.push(variantFetch);
          variantFetch.then((data) => {
            if (!data) {
              outputArray[index] += opts.passDataToTemplate(hit);
            } else {
              hit['hover_img'] = '';
              if (!window.touchDevice) {
                const hoverImg = custom.algoliaUtils.getHoverImage(data);
                hit['hover_img'] = hoverImg ? hoverImg : '';
              }
              const sizes =
                hit.product_type === 'PILLOWS' || hit.product_type === 'POUFS'
                  ? custom.algoliaUtils.getPillowSizeObject(data)
                  : custom.algoliaUtils.getArtSizeObject(data);
              hit = Object.assign({}, hit, { sizes: sizes });
              outputArray[index] += sizes
                ? window.pillowCardTemplate.render(hit)
                : opts.passDataToTemplate(hit);
            }
          });
        }
        // RUGS, THROWS, WALL HANGINGS, ANIMAL TROPHIES
        else {
          // Concatenate output
          // Will output JSON to results container if template isn't defined
          if (opts.searchIndex && hit.isCollection) {
            outputArray[index] += opts.passDataToTemplate
              ? window.collectionCardTemplate.render(hit)
              : JSON.stringify(hit);
          } else {
            if (hit.product_type === 'RUGS') {
              const variantFetch = custom.shopifyApi.getShopifyProductJson(
                hit.handle,
              );
              variantsPromises.push(variantFetch);
              variantFetch.then((data) => {
                if (data) {
                  hit['hover_img'] = '';
                  if (!window.touchDevice) {
                    const hoverImg = custom.algoliaUtils.getHoverImage(data);
                    hit['hover_img'] = hoverImg ? hoverImg : '';
                  }
                }
                outputArray[index] += opts.passDataToTemplate
                  ? opts.passDataToTemplate(hit)
                  : JSON.stringify(hit);
              });
            } else {
              outputArray[index] += opts.passDataToTemplate
                ? opts.passDataToTemplate(hit)
                : JSON.stringify(hit);
            }
          }
        }
      });

      if (variantsPromises.length > 0) {
        // NOTE: Here we might need to remove Error Promise
        // from variantsPromises array since it'll keep calling
        // custom.algoliaUtils.removeErrorPromiseFromArray
        Promise.all(variantsPromises).then((data) => {
          //only render results if handle doesn't already exist
          if (
            !$('#' + opts.resultsContainerID + ' #' + handle).length ||
            state.refinementsChange ||
            state.queryChange ||
            (!collectionMode && state.indexChange) ||
            (collectionMode && state.indexCollectionChange)
          ) {
            renderResults(
              outputArray.join(''),
              collectionMode,
              isLastPage,
              resultQueryID,
            );
          }
          resultsLoadedCallback(collectionMode);
          custom.productsInCollection.updateCollectionPrices();
        });
      } else {
        renderResults(
          outputArray.join(''),
          collectionMode,
          isLastPage,
          resultQueryID,
        );
        resultsLoadedCallback(collectionMode);
        custom.productsInCollection.updateCollectionPrices();
      }
    };

    // Method to render collection cards to UI
    const renderProductsToUI = (hits, isLastPage = false) => {
      let hitHandles = [];
      // Loop through each hit and get product images
      hits.forEach((hit) => {
        if (hitHandles.includes(hit.handle)) return;
        hitHandles.push(hit.handle);
        if (hit['meta']['loloi']['products_json']) {
          var products = JSON.parse(
            custom.utils.unescapeUtil(hit['meta']['loloi']['products_json']),
          );
          hit = custom.algoliaUtils.collectionImageMapper(hit, products);
        } else {
          hit = custom.algoliaUtils.collectionImageMapper(hit);
        }
      });
      // Render results, promise returned
      renderCardsToUI(hits, true, isLastPage);
      // Callbacks
      if (opts.cardRenderedCallback) assignCallbackToCards(hits);
    };

    // Callback assigned to rendered card
    const assignCallbackToCards = (hits) => {
      hits.forEach((hit) => {
        opts.cardRenderedCallback(hit);
      });
    };

    /**
     * MAKE_HITS =============================================
     *
     * Allows us to alter the response before outputting to results container
     * We do this because we augment the InstantSearch object with a Products->Images Search Query
     */

    /**
     * infiniteLoadMoreHandler
     *
     * Allows us to alter the response before outputting to results container
     * We do this because we augment the InstantSearch object with a Products->Images Search Query
     */
    function infiniteLoadMoreHandler(collectionSearch = false) {
      const targetResultsContainerID = collectionSearch
        ? `${opts.resultsContainerID}-collection`
        : opts.resultsContainerID;
      const targetLoadMoreContainerID = collectionSearch
        ? `${opts.loadMoreContainerID}-collection`
        : opts.loadMoreContainerID;
      const targetLoadMoreID = collectionSearch
        ? `${opts.loadMoreID}-collection`
        : opts.loadMoreID;
      let targetLoadMoreTrigger;
      let targetLoadMoreCounter;

      return algoliaEsHolder.connectors.connectInfiniteHits(
        ({ hits, showMore, results, isLastPage }, isFirstRendering) => {
          // If first time rendering, add load more button to the load more container if it doesn't exist yet
          if (isFirstRendering) {
            if (document.getElementById(targetLoadMoreID) == null) {
              // Cache required elements
              const loadMoreContainer = document.getElementById(
                targetLoadMoreContainerID,
              );
              loadMoreContainer.innerHTML = `<button id="${targetLoadMoreID}" class="btn btn--secondary product-showcase__load-more-button">Load More</button><p class="text-center utility-xsmall mt-12 mb-8 content-subtle"><strong id="${targetLoadMoreID}--count" class="product-showcase__load-more-count"></strong></p>`;
              targetLoadMoreTrigger = document.getElementById(targetLoadMoreID);
              targetLoadMoreCounter = document.getElementById(
                `${targetLoadMoreID}--count`,
              );
              targetLoadMoreTrigger.addEventListener('click', () => {
                targetLoadMoreTrigger.innerHTML = 'Loading...';
                state.setRefinementStateFresh = true;
                state.setQueryStateFresh = true;
                showMore();
              });
            }
            return;
          }

          const { nbHits, nbPages, page, queryID, index } = results;
          if (targetLoadMoreTrigger) {
            const remainingHitsCount = Math.max(nbHits - hits.length, 0);
            const loadMoreCount =
              opts.instantSearchLimit > remainingHitsCount
                ? remainingHitsCount
                : opts.instantSearchLimit;
            targetLoadMoreTrigger.innerHTML = isLastPage
              ? 'All Results Shown'
              : `Load ${loadMoreCount} More ${
                  collectionSearch ? 'Collections' : 'Products'
                }`;
            targetLoadMoreTrigger.disabled = isLastPage ? true : false;
          }
          if (targetLoadMoreCounter) {
            const hitLength = hits.length > nbHits ? nbHits : hits.length;
            targetLoadMoreCounter.innerHTML = `Showing ${hitLength} of ${nbHits}`;
          }
          // BUGFIX LR-719: Don't rerender if the queryID is already in the recentQueryIds array -- previously rendered search results are also getting called by the inifitinteLoadMore method and sometimes also getting rendered.
          // queryID is not always available in the results object, so we need to check if it's available and then just use the hit numbers, page numbers, and current page as a fallback.
          const resultQueryID = `${
            queryID ? queryID : 'noId'
          }-${nbHits}-${nbPages}-${page}-${index}`;
          if (state.recentQueryIds.indexOf(resultQueryID) > -1) {
            return;
          }
          //Don't add to recentQueryIds if no hits -- empty results should be handled by either resultsLoadedCallback or handleNoResults
          if (nbHits > 0) {
            state.recentQueryIds.unshift(resultQueryID);
            if (state.recentQueryIds.length > 2) {
              state.recentQueryIds = state.recentQueryIds.slice(0, 2);
            }
          } else {
            state.recentQueryIds = [];
          }
          // setSearchIndexState was also getting called multiple times -- this is a bugfix for that LR-797
          const sortBySelectorWidget = opts.widgets.find(
            (widget) => widget.widgetType == 'sortBySelector',
          );
          setSearchIndexState(
            index,
            sortBySelectorWidget ? sortBySelectorWidget.widgetOptions : null,
          );
          //End Bugfix

          // for collections keep track of what page we're on
          let renderItems = isFirstRendering ? hits : results.hits;
          if (!hits.length && results.hits && results.hits.length) {
            renderItems = results.hits;
          }

          if (collectionSearch) {
            setSearchCollectionPageState(results.page);
            if (
              !state.pageCollectionChange &&
              !state.refinementsChange &&
              !state.indexCollectionChange &&
              !state.queryChange
            ) {
              state.recentQueryIds = [];
              return;
            }
          } else {
            setSearchPageState(results.page);
            //skip if page hasn't changed
            if (
              !state.pageChange &&
              !state.refinementsChange &&
              !state.indexChange &&
              !state.queryChange
            ) {
              state.recentQueryIds = [];
              return;
            }
          }

          // Track PLP view item list in products view only
          if (
            !collectionSearch &&
            !$('#' + opts.resultsContainerID).hasClass('hidden')
          ) {
            let gtmListId = opts.gtm_list_id
              ? opts.gtm_list_id
              : 'Product Listing Page';
            if (state.currentQuery && state.currentQuery != '') {
              gtmListId = state.currentQuery;
            }
            const startIndex = results.page * results.hitsPerPage;

            const data = {
              ecommerce: {
                currency: 'USD',
                item_list_name: opts.gtm_list_name
                  ? opts.gtm_list_name
                  : 'Category',
                item_list_id: gtmListId,
                items: results.hits.map((hit, index) => {
                  let searchItem = {
                    item_id: hit.id.toString(),
                    item_name: hit.title ? hit.title : hit.name,
                    index: index + startIndex + 1,
                  };
                  if (hit.named_tags && hit.named_tags.Collection)
                    searchItem['item_brand'] = hit.named_tags.Collection;
                  if (hit.named_tags && hit.named_tags.Collaboration)
                    searchItem['item_collaboration'] =
                      hit.named_tags.Collaboration;
                  if (hit.named_tags && hit.named_tags.Color)
                    searchItem['item_color'] = hit.named_tags.Color.toString();

                  return searchItem;
                }),
              },
            };
            custom.gtmDatalayer.gtmPushNew(data, 'view_item_list');
          }

          if (renderItems.length && !isFirstRendering) {
            // Disable button on last page
            if (targetLoadMoreTrigger)
              targetLoadMoreTrigger.disabled = isLastPage;

            // If product search only, render here
            if (!opts.searchIndex) {
              return renderCardsToUI(
                renderItems,
                false,
                isLastPage,
                resultQueryID,
              );
            }

            if (collectionSearch) {
              return !state.filterApplied
                ? (() => {
                    setRefinementState([]);
                    renderProductsToUI(renderItems, isLastPage, resultQueryID);
                  })()
                : false; // Collection Render
            } else {
              // Product Render : Collection Refresh
              // Need to determine if we need to collection refresh or not
              // Check both state.filterApplied (set on interactive changes) and countCurrentFilters()
              // (checks helper state directly, needed for URL filters on initial load)
              const hasFiltersApplied =
                state.filterApplied || countCurrentFilters() > 0;
              if (hasFiltersApplied) {
                return renderCardsToUI(
                  renderItems,
                  false,
                  isLastPage,
                  resultQueryID,
                );
              } else {
                if ($('#' + targetResultsContainerID).children().length == 0) {
                  //no products loaded yet
                  return;
                } else {
                  return collectionInstantSearch.refresh();
                }
              }
            }
          }
          //LR-667 - for some reason page 2 was being called too quickly and if no results would hide the section
          if (!renderItems.length && !isFirstRendering && results.page == 0) {
            // No results found
            return handleNoResults(state.filterApplied);
          }
        },
      );
    }

    /**
     * paginateHandler
     *
     * Allows us to alter the response before outputting to results container
     * We do this because we augment the InstantSearch object with a Products->Images Search Query
     */
    function paginateHandler() {
      return algoliaEsHolder.connectors.connectHits(({ hits }) => {
        if (hits.length) {
          // If collection, reach out to products search for more cards
          opts.searchIndex ? renderProductsToUI(hits) : renderCardsToUI(hits);
        }
      });
    }

    // MAKEHITS connector
    const makeHits = (collectionSearch = false) => {
      return opts.loadMore
        ? infiniteLoadMoreHandler(collectionSearch)
        : paginateHandler();
    };

    /**
     * WIDGETS =============================================
     *
     *
     */

    /**
     * Add Widget Factory
     * All widgets and widget options are defined in template side.
     * Here just adding widgets to our Instant Search instance.
     */
    const addWidgetFactory = () => {
      if (!opts.widgets) return;
      opts.widgets.forEach(({ widgetType, widgetOptions }) => {
        custom.algoliaWidgetBuilder.buildWidget(
          myInstantSearch,
          algoliaEsHolder,
          widgetType,
          widgetOptions,
        );
      });

      // ========== "CurrentRefinedValues"
      const makeCurrentRefinedValues =
        algoliaEsHolder.connectors.connectCurrentRefinements(
          ({ items, widgetParams }, isFirstRendering) => {
            setRefinementState(items);
          },
        );
      myInstantSearch.addWidgets([makeCurrentRefinedValues()]); // add to widget

      // ========== "searchBox"
      const searchBoxWidget = opts.widgets.find(
        (widget) => widget.widgetType == 'searchBox',
      );
      if (searchBoxWidget) {
        const makeSearchBox = algoliaEsHolder.connectors.connectSearchBox(
          ({ query }, isFirstRendering) => {
            setQueryState(query);
          },
        );
        myInstantSearch.addWidgets([
          makeSearchBox(searchBoxWidget.widgetOptions),
        ]); // add to widget
      }

      // ========== "stats"
      const statsWidget = opts.widgets.find(
        (widget) => widget.widgetType == 'stats',
      );
      if (statsWidget)
        myInstantSearch.addWidgets([
          algoliaEsHolder.widgets.stats(statsWidget.widgetOptions),
        ]); // add to widget
    };

    /**
     * Add Collection Widget Factory
     * For COLLECTION Search
     * All widgets and widget options are defined in template side.
     */
    const addCollectionWidgetFactory = () => {
      if (!opts.collectionWidgets) return;

      opts.collectionWidgets.forEach(({ widgetType, widgetOptions }) => {
        custom.algoliaWidgetBuilder.buildWidget(
          collectionInstantSearch,
          algoliaEsHolder,
          widgetType,
          widgetOptions,
        );
      });

      // ========== "SortBySelector"
      const sortBySelectorCollectionWidget = opts.collectionWidgets.find(
        (widget) => widget.widgetType == 'sortBySelector',
      );
      const makeSortBySelectorCollection =
        algoliaEsHolder.connectors.connectSortBy(
          (renderOptions, isFirstRendering) => {
            const { currentRefinement, widgetParams } = renderOptions;
            if (!isFirstRendering) {
              setSearchCollectionIndexState(currentRefinement, widgetParams);
            }
            custom.dropdownToRadio.init();
          },
        );
      if (sortBySelectorCollectionWidget) {
        collectionInstantSearch.addWidgets([
          makeSortBySelectorCollection(
            sortBySelectorCollectionWidget.widgetOptions,
          ),
        ]); // add to widget
      }
    };

    // All Filter Initialization
    addWidgetFactory();
    if (opts.searchIndex) addCollectionWidgetFactory();

    // add MAKE_HITS to the widgets
    myInstantSearch.addWidgets([makeHits()()]);
    myInstantSearch.start();

    const countCurrentFilters = () => {
      let filterCount = 0;
      if (myInstantSearch.helper && myInstantSearch.helper.state) {
        const { disjunctiveFacetsRefinements, numericRefinements } =
          myInstantSearch.helper.state;
        Object.keys(disjunctiveFacetsRefinements).forEach((key) => {
          if (disjunctiveFacetsRefinements[key].length > 0) {
            filterCount++;
          }
        });
        Object.keys(numericRefinements).forEach((key) => {
          if (JSON.stringify(numericRefinements[key]) !== '{}') {
            filterCount++;
          }
        });
      }
      return filterCount;
    };

    if (opts.searchIndex) {
      collectionInstantSearch.addWidgets([makeHits(true)()]);
      collectionInstantSearch.start();
      //Check if filters are applied and switch search mode appropriately
      collectionInstantSearch.on('render', () => {
        initialRenderCallback();
        let filterCount = countCurrentFilters();
        let filterApplied = filterCount > 0;
        custom.algoliaUtils.updateFiltersBar(filterCount);
        custom.algoliaUtils.updateDoorwayDriver(filterCount);
        SearchModeHandler(!filterApplied, false);
      });
    } else {
      myInstantSearch.on('render', () => {
        initialRenderCallback();
        let filterCount = countCurrentFilters();
        custom.algoliaUtils.updateFiltersBar(filterCount);
        custom.algoliaUtils.updateDoorwayDriver(filterCount);
      });
    }
  };

  // Make public
  return {
    init,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/algolia-search.js